import { getEntitlementRouteCCPV2 } from '@atlassian/cssxp-utils-entitlement';
import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { Link } from 'react-router-dom';
import { CustomPanel } from '../../custom-panel';
import { DynamicResultTable } from '../../dynamic-result-table';
import EntitlementIcon from '../../entitlement-icon';
import './subscriptions-by-bill-date.scss';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';

interface Props {
  billingDate: string;
  entitlements: EntitlementDetails[];
  focused?: boolean | null | undefined;
  isTermed?: boolean;
}

const wrapInCell = (node?: React.ReactElement | string | null) => {
  return <div className="subscription-cell">{node}</div>;
};

const getHead = () => {
  const cells = [
    {
      content: 'Subscription',
      width: 50,
    },
    {
      content: 'Billing cycle',
      width: 20,
    },
    {
      content: 'Site URL',
      width: 30,
    },
  ];

  return {
    cells,
  };
};

const makeRows = (entitlements: EntitlementDetails[]) => {
  return entitlements.map((entitlement) => {
    const {
      entitlementNumber,
      edition,
      billingFrequency,
      productName,
      productId, //TODO: Need product ID in the response
      cloudSiteHostname,
    } = entitlement;
    const rowKey = `entitlement-${productId}`;
    return {
      key: rowKey,
      cells: [
        {
          content: wrapInCell(
            <>
              <Link
                to={getEntitlementRouteCCPV2(productId, entitlementNumber as string)}
                target="_blank"
                onClick={(e) => e.stopPropagation()}
                className="set-bill-date-container__info__subscription__col__cell__avatar-container"
              >
                {!!productId && <EntitlementIcon productId={productId} isCloud={true} className="avatar medium" />}
                <span id="product-name" data-testid={productId}>
                  {productName ?? 'Unnamed product'}
                </span>
              </Link>
              <div className="product-details">
                <div>Plan: {edition}</div>
                <div>{entitlementNumber}</div>
              </div>
            </>
          ),
        },
        {
          content: wrapInCell(capitalize(billingFrequency ?? '')),
        },
        {
          content: wrapInCell(cloudSiteHostname),
        },
      ],
    };
  });
};

const getHeader = (billingDate: string, isTermed?: boolean) => {
  return (
    <div className="bill-date-header">
      <div className="tab-heading">{`View subscriptions with this ${isTermed ? 'end' : 'bill'} date`}</div>
      <div>
        <span className="subheading">
          <p>{`${isTermed ? 'End' : 'Bill'} date`}</p>
        </span>
        <p className="bill-date">{billingDate}</p>
      </div>
    </div>
  );
};

const SubscriptionsByBillDate = ({ billingDate, entitlements, focused, isTermed }: Props) => {
  return (
    <div className={classNames('subscriptions-by-bill-date-container', { focused })}>
      <CustomPanel
        expandedHeader={getHeader(billingDate, isTermed)}
        collapsedHeader={getHeader(billingDate, isTermed)}
        isExpanded={false}
      >
        <div className="subscriptions-container">
          <DynamicResultTable
            head={getHead()}
            rows={makeRows(entitlements)}
            loadingSpinnerSize="small"
            emptyStateProps={{
              header: '',
              description: 'No subscriptions found',
            }}
            boxShadow={false}
            alternateRowColor={false}
          ></DynamicResultTable>
        </div>
      </CustomPanel>
    </div>
  );
};

export default SubscriptionsByBillDate;
